// extracted by mini-css-extract-plugin
export var benefits = "benefitsList-module--benefits--JW_yx";
export var jsAnimInit = "benefitsList-module--jsAnimInit--2op08";
export var title = "benefitsList-module--title--3yOR7";
export var text = "benefitsList-module--text--11e05";